<!--<div fxLayout="row" fxLayoutAlign="space-around stretch" >-->
<div style="height: 100%">
  <div
    *ngFor="let statusKey of statusesKeys"
    fxLayout="column"
    fxLayoutAlign="start center"
    fxFlex="25"
    class="m-2"
    style="overflow-x: hidden"
  >
    <div class="text-center rounded-top w-100 font-weight-bolder">
      {{ medReviewStatuses[statusKey] }}
    </div>
    <div
      style="
        min-height: 250px;
        max-height: 600px;
        height: 600px;
        overflow-y: auto;
        width: 100%;
        overflow-x: auto;
      "
    >
      <ng-container *ngFor="let card of statusData[statusKey]">
        <kt-med-review-card
          *ngIf="showCardForMedType(card)"
          [patient_id]="data.patient_id"
          [data]="card"
          [statusKey]="statusKey"
          [moveToDiscontinued]="moveToDiscontinued.bind(this)"
          [fromPatient]="fromPatient"
        ></kt-med-review-card>
      </ng-container>
    </div>
  </div>
</div>
<!--</div>-->
